import { store } from "..";
import { isLocationPermissionGrantedWeb, storeAddressAtBackend } from "../../components/LocationCheck/helper";
import {
  HIDE_GOOGLE_LOGIN_MODAL,
  HIDE_LOCATION_MODAL,
  IS_AUTH_API_RESPONSE_STATUS,
  SET_LOCATION_PERMISSION_STATUS,
  SHOW_GOOGLE_LOGIN_MODAL,
  SHOW_LOCATION_MODAL,
} from "../reduxConstants";

export const setLocationPermissionStatus = (locationPermissionStatus) => ({
  type: SET_LOCATION_PERMISSION_STATUS,
  locationPermissionStatus,
});

export const showLocationModal = (locationErrorObject) => ({
  type: SHOW_LOCATION_MODAL,
  locationErrorObject,
});

export const checkLocationAndShowLocationModal = async (
  locationErrorObject,
  callback
) => {
  const isLocationPermissionGranted = await isLocationPermissionGrantedWeb();

  // if (isLocationPermissionGranted) {
  //   store.dispatch(hideLocationModal()); //TODO may not be needed added for safety
  //   storeAddressAtBackend(locationErrorObject, callback);
  // } else {
    store.dispatch(showLocationModal(locationErrorObject));
  // }
};

export const hideLocationModal = () => ({
  type: HIDE_LOCATION_MODAL,
});

export const setAuthApiResponseStatus = (isAuthApiResponseStatus) => ({
  type: IS_AUTH_API_RESPONSE_STATUS,
  isAuthApiResponseStatus,
})

export const showGoogleLoginModal = () => ({
  type: SHOW_GOOGLE_LOGIN_MODAL,
})

export const hideGoogleLoginModal = () => ({
  type: HIDE_GOOGLE_LOGIN_MODAL,
})
